import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { getFeaturedMovies } from '@/mocks/movies';

export default function FeaturedMovies() {
  const featuredMovies = getFeaturedMovies();

  return (
    <section className="py-16 md:py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">
              精选推荐
            </h2>
            <p className="text-cinema-text-dim text-sm mt-2">精心挑选的高品质电影，不容错过</p>
          </div>
          <Link
            to="/category/gaofen"
            className="hidden sm:flex items-center gap-1 text-cinema-gold text-sm hover:text-cinema-gold-light transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {featuredMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/gaofen"
            className="inline-flex items-center gap-1 text-cinema-gold text-sm hover:text-cinema-gold-light transition-colors cursor-pointer"
          >
            查看全部推荐 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}